<template>
    <div></div>
    <!-- <div class="Login">
        <el-form class="login-box" >
            <el-tabs stretch="">
                <el-tab-pane label="读者登陆" value="first">
                    <Login></Login>
                </el-tab-pane>
                <el-tab-pane label="管理者登录" name="second"
                    ><Register></Register
                ></el-tab-pane>
            </el-tabs>
        </el-form>
    </div> -->
</template>
<script>
import Register from "../views/Login/Register";
import Login from "../views/Login/Login";
export default {
    components: {
        Register,
        Login,
    },
    data() {
        return {
            activeName: "first",
            // aaa: true,
            pic: require('../assets/images/no_cover3.png'),
        };
    },
    created() {
        //  this.$nextTick(_ => {
        //   const activeBarElement = document.getElementsByClassName('el-tabs__active-bar')[0]
        //   activeBarElement.style.width = '155px';
        // })
    },
    methods: {},
};
</script>
 
<style lang="scss" scoped>
html,body {
    height: 100%;
    width: 100%;
}
.Login {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999;
    background-color: rgba(34, 31, 31,0.4);
    .login-box {
        position: absolute;
        border: 1px solid #dcdfe6;
        width: 350px;   
        z-index: 200;
        background-color: #dcdfe6;
        /* margin: 180px auto; */
        margin: 0 auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 100;
        padding: 35px 35px 15px 35px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0 0 25px #909399;
    }

}
::v-deep.el-tabs__active-bar.is-top{
    width: 150px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/LogReg.vue